const newArea = {
  snackbar: "Ihr Update ist fertig",
  name: "Zonenname",
  save: "Speichern",
  cancel: "Stornieren",
  area: "Zone",
  formTitle: "Neue Zone",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen",
  selectCompany: "Wählen Sie eine Firma aus"
};
export default newArea;
